import { Box } from 'components/Box';
import Icon from 'components/Icon/Icon.component';
import { Translate } from 'react-localize-redux';
import { useIsApp } from 'utils/hooks/useGetIsApp';
import noMinorsLogo from '../icons/18_logo.svg';
import frGovLogo from '../icons/fr_gov_logo.png';
import { FrBannerContainer } from './betting-warning-banner-container';
import { GovAnchor } from './gov-anchor';

/*------------------------------types------------------------------*/

type FrBettingWarningBannerProps = {
  isSticky?: boolean;
};

/*------------------------------component------------------------------*/

function FrBettingWarningBanner({ isSticky }: FrBettingWarningBannerProps) {
  const isApp = useIsApp();

  return (
    <FrBannerContainer isSticky={isSticky} isApp={isApp}>
      <GovAnchor href="https://www.joueurs-info-service.fr/" target="_blank">
        <Translate id="frBettingWarningBanner.warningMessage" />
      </GovAnchor>
      <Box minWidth={'70px'} marginRight={'32px'}>
        <Icon iconSize="70px" iconHeight="40px" iconSrc={frGovLogo} />
      </Box>
      <Box
        width={'32px'}
        height={'100%'}
        background={'#222222'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        position={'absolute'}
        top={0}
        right={0}
      >
        <Icon iconSize="16px" iconHeight="16px" iconSrc={noMinorsLogo} />
      </Box>
    </FrBannerContainer>
  );
}

export { FrBettingWarningBanner };
